import { render } from "./CompetitionActions.vue?vue&type=template&id=470d5026&scoped=true"
import script from "./CompetitionActions.vue?vue&type=script&lang=js"
export * from "./CompetitionActions.vue?vue&type=script&lang=js"

import "./CompetitionActions.vue?vue&type=style&index=0&id=470d5026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470d5026"]])

export default __exports__